interface IEnv {
  acsesBaseURL: string;
  appointmentBaseURL: string;
  appointmentBaseURLv2: string;
  authBaseURL: string;
  bandenExpressOrderPortalURL: string;
  carBaseURL: string;
  commBaseURL: string;
  customComBaseURL: string;
  dealerBaseURL: string;
  deskBaseURL: string;
  dmsAccessorBaseURL: string;
  dmsv3BaseURL: string;
  exactBaseURL: string;
  exportBaseURL: string;
  googleClientID: string;
  holdingBaseURL: string;
  keylockerBaseURL: string;
  kioskBaseURL: string;
  microsoftClientID: string;
  notifierEndpoint: string;
  planitBaseURL: string;
  reportsBaseURL: string;
  shareboxBaseURL: string;
  storageI18n: string;
  systemBaseURL: string;
  systemBaseURLv2: string;
  twilioBaseURL: string;
  tyreNetBaseURL: string;
  tyreNetBaseURLV2: string;
  tyreTeamBaseURL: string;
  tyreTeamBaseURLV2: string;
  wheelTireOrderPortalURL: string;
  zohoASAP: string;
}

interface IEnvironments {
  dev: IEnv;
  local: IEnv;
  prod: IEnv;
}

const ENVIRONMENTS: IEnvironments = {
  dev: {
    acsesBaseURL: "https://v8.clairedev.nl/api/acses/v1",
    appointmentBaseURL: "https://v8.clairedev.nl/api/appointment/v1",
    appointmentBaseURLv2: "https://v8.clairedev.nl/api/appointment/v2",
    authBaseURL: "https://v8.clairedev.nl/api/auth/v1",
    bandenExpressOrderPortalURL: "https://test-081.bexweb.nl",
    carBaseURL: "https://v8.clairedev.nl/api/car/v1",
    commBaseURL: "https://comm.clairedev.nl",
    customComBaseURL: "https://v8.clairedev.nl/api/customcom/v1",
    dealerBaseURL: "https://v8.clairedev.nl/api/dealer/v1",
    deskBaseURL: "https://v8.clairedev.nl/api/desk/v1",
    dmsv3BaseURL: "https://v8.clairedev.nl/api/dmsv3/v1",
    dmsAccessorBaseURL: "https://v8.clairedev.nl/api/dmsaccessor/v1",
    exactBaseURL: "https://v8.clairedev.nl/api/exact/v1",
    exportBaseURL: "https://v8.clairedev.nl/api/export/v1",
    googleClientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    holdingBaseURL: "https://v8.clairedev.nl/api/holding/v1",
    keylockerBaseURL: "https://v8.clairedev.nl/api/keylocker/v1",
    kioskBaseURL: "https://v8.clairedev.nl/api/kiosk/v1",
    microsoftClientID: "2c4cd78d-bc1c-4c97-a974-db6b20ecb75e",
    notifierEndpoint: "wss://notifier.clairedev.nl",
    planitBaseURL: "https://v8.clairedev.nl/api/planit/v1",
    reportsBaseURL: "https://v8.clairedev.nl/api/report/v1",
    shareboxBaseURL: "https://v8.clairedev.nl/api/sharebox/v1",
    storageI18n: "https://storage.googleapis.com/clairei18n",
    systemBaseURL: "https://v8.clairedev.nl/api/system/v1",
    systemBaseURLv2: "https://v8.clairedev.nl/api/system/v2",
    twilioBaseURL: "https://v8.clairedev.nl/api/twilio/v1",
    tyreNetBaseURL: "https://v8.clairedev.nl/api/tyrenet/v1",
    tyreNetBaseURLV2: "https://v8.clairedev.nl/api/tyrenet/v2",
    tyreTeamBaseURL: "https://v8.clairedev.nl/api/tyreteam/v1",
    tyreTeamBaseURLV2: "https://v8.clairedev.nl/api/tyreteam/v2",
    wheelTireOrderPortalURL: "https://test-011.webdis.nl",
    zohoASAP: "https://desk.zoho.eu/portal/api/web/asapApp/172650000043833003?orgId=20098974504"
  },
  local: {
    acsesBaseURL: "http://localhost:8081/api/acses/v1",
    appointmentBaseURL: "http://localhost:8082/api/appointment/v1",
    appointmentBaseURLv2: "http://localhost:8082/api/appointment/v2",
    authBaseURL: "http://localhost:8083/api/auth/v1",
    bandenExpressOrderPortalURL: "https://test-081.bexweb.nl",
    carBaseURL: "http://localhost:8084/api/car/v1",
    commBaseURL: "https://comm.clairedev.nl",
    customComBaseURL: "http://localhost:8086/api/customcom/v1",
    dealerBaseURL: "http://localhost:8087/api/dealer/v1",
    deskBaseURL: "http://localhost:8088/api/desk/v1",
    dmsAccessorBaseURL: "http://localhost:8089/api/dmsaccessor/v1",
    dmsv3BaseURL: "http://localhost:8090/api/dmsv3/v1",
    exactBaseURL: "http://localhost:8091/api/exact/v1",
    exportBaseURL: "http://localhost:8092/api/export/v1",
    googleClientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    holdingBaseURL: "http://localhost:8093/api/holding/v1",
    keylockerBaseURL: "http://localhost:8096/api/keylocker/v1",
    kioskBaseURL: "http://localhost:8098/api/kiosk/v1",
    microsoftClientID: "2c4cd78d-bc1c-4c97-a974-db6b20ecb75e",
    notifierEndpoint: "wss://notifier.clairedev.nl",
    planitBaseURL: "http://localhost:8101/api/planit/v1",
    reportsBaseURL: "http://localhost:8104/api/report/v1",
    shareboxBaseURL: "http://localhost:8105/api/sharebox/v1",
    storageI18n: "https://storage.googleapis.com/clairei18n",
    systemBaseURL: "http://localhost:8106/api/system/v1",
    systemBaseURLv2: "http://localhost:8106/api/system/v2",
    twilioBaseURL: "https://localhost:8110/nl/api/twilio/v1",
    tyreNetBaseURL: "http://localhost:8110/api/tyrenet/v1",
    tyreNetBaseURLV2: "http://localhost:8110/api/tyrenet/v2",
    tyreTeamBaseURL: "http://localhost:8111/api/tyreteam/v1",
    tyreTeamBaseURLV2: "http://localhost:8111/api/tyreteam/v2",
    wheelTireOrderPortalURL: "https://test-011.webdis.nl",
    zohoASAP: "https://desk.zoho.eu/portal/api/web/asapApp/172650000043833003?orgId=20098974504"
  },
  prod: {
    acsesBaseURL: "https://v8.claireit.com/api/acses/v1",
    appointmentBaseURL: "https://v8.claireit.com/api/appointment/v1",
    appointmentBaseURLv2: "https://v8.claireit.com/api/appointment/v2",
    authBaseURL: "https://v8.claireit.com/api/auth/v1",
    bandenExpressOrderPortalURL: "https://bexweb.nl/",
    carBaseURL: "https://v8.claireit.com/api/car/v1",
    commBaseURL: "https://mycarcheck.pro",
    customComBaseURL: "https://v8.claireit.com/api/customcom/v1",
    dealerBaseURL: "https://v8.claireit.com/api/dealer/v1",
    deskBaseURL: "https://v8.claireit.com/api/desk/v1",
    dmsAccessorBaseURL: "https://v8.claireit.com/api/dmsaccessor/v1",
    dmsv3BaseURL: "https://v8.claireit.com/api/dmsv3/v1",
    exactBaseURL: "https://v8.claireit.com/api/exact/v1",
    exportBaseURL: "https://v8.claireit.com/api/export/v1",
    googleClientID: "674901036874-hrv3lhqlkp3b0uh8lhoaj0hlmrqd37it.apps.googleusercontent.com",
    holdingBaseURL: "https://v8.claireit.com/api/holding/v1",
    keylockerBaseURL: "https://v8.claireit.com/api/keylocker/v1",
    kioskBaseURL: "https://v8.claireit.com/api/kiosk/v1",
    microsoftClientID: "2b491317-d832-4533-b07b-95419a4d739c",
    notifierEndpoint: "wss://notifier.claireit.com",
    planitBaseURL: "https://v8.claireit.com/api/planit/v1",
    reportsBaseURL: "https://v8.claireit.com/api/report/v1",
    shareboxBaseURL: "https://v8.claireit.com/api/sharebox/v1",
    storageI18n: "https://storage.googleapis.com/clairei18n-prod",
    systemBaseURL: "https://v8.claireit.com/api/system/v1",
    systemBaseURLv2: "https://v8.claireit.com/api/system/v2",
    twilioBaseURL: "https://v8.claireit.com/api/twilio/v1",
    tyreNetBaseURL: "https://v8.claireit.com/api/tyrenet/v1",
    tyreNetBaseURLV2: "https://v8.claireit.com/api/tyrenet/v2",
    tyreTeamBaseURL: "https://v8.claireit.com/api/tyreteam/v1",
    tyreTeamBaseURLV2: "https://v8.claireit.com/api/tyreteam/v2",
    wheelTireOrderPortalURL: "https://www.webdis.nl/",
    zohoASAP: "https://desk.zoho.eu/portal/api/web/asapApp/99375000043916017?orgId=20081393645"
  }
};

let ENV = ENVIRONMENTS.dev;
if (import.meta.env.PUBLIC_ENV === "dev" || import.meta.env.PUBLIC_ENV === "local" || import.meta.env.PUBLIC_ENV === "prod")
  ENV = ENVIRONMENTS[import.meta.env.PUBLIC_ENV];

export default ENV;
